class pricechart extends Tango.Component {
	init() {
		// Default state; arbitrary params are added later via SetCtrlState
		this.state = {
			z: this.props.initialZoom ?? null,
		};
	}

	widgetDidMount() {
		const _this = this;
		const root = document.getElementById(this.root);
		const parent = root.parentElement.parentElement;
		
		if (this.props.zoom_in && this.props.zoom_out) {
			const zoom_in = document.getElementById(this.props.zoom_in);
			const zoom_out = document.getElementById(this.props.zoom_out);

			zoom_in.onclick = e => {
				if (!_this.state.z)
					_this.state.z = this.calcZ();

				_this.state.z = _this.state.z * 2;
				if (_this.state.z > 1)
					zoom_out.style.display = '';
				if (_this.state.z == 32)
					zoom_in.style.display = 'none';
				_this.initChart(root, parent);
			};

			zoom_out.onclick = e => {
				if (!_this.state.z)
					_this.state.z = this.calcZ();

				_this.state.z = _this.state.z / 2;
				if (_this.state.z == 1)
					zoom_out.style.display = 'none';
				if (_this.state.z < 32)
					zoom_in.style.display = '';
				_this.initChart(root, parent);
			};
		}

		function onChartResize(e) {
			_this.initChart(root, parent);
		}
		new ResizeObserver(onChartResize).observe(parent);
	}

	calcZ() {
		return devicePixelRatio > 0 && devicePixelRatio < 2 ? 4 :
			devicePixelRatio >= 2 && devicePixelRatio < 3 ? 8 : 16;
	}

	initChart(root, parent) {
		const rect = parent.getBoundingClientRect();
		if (rect.width == 0 && rect.height == 0) return;

		var w = rect.width | 0;

		if (!Number.isInteger(devicePixelRatio)) {
			while (w > rect.width - 10 && !Number.isInteger(w * devicePixelRatio))
				w--;
		}

		if (!Number.isInteger(w * devicePixelRatio) && Tango.isMobile())
			w = w - 8;

		const rootRect = root.getBoundingClientRect();
		const parms = {
			...this.state,
			w: w | 0,
			h: rootRect.height | 0,
			pr: devicePixelRatio.toFixed(3),
			z: this.state.z ?? this.calcZ()
		};

		var url = '/data/' + this.props.service + '/' + this.props.action + '?';
		for (var key in parms) {
			url += key + '=' + encodeURIComponent(parms[key]) + '&';
		}

		const img = root.querySelector('img');
		const imgPar = img.parentElement;
		imgPar.removeChild(img);
		img.src = url;
		img.onerror = () => {
			if (imgPar.querySelector('.nodata'))
				return;
			img.classList.add('hide');
			imgPar.appendChild(img);
			const div = document.createElement('div');
			div.className = 'nodata';
			const w = new Tango.HtmlWriter();
			const icon = w.Icon('nodata');
			const text = document.createElement('div');
			text.innerText = 'No data to show';
			div.appendChild(icon);
			div.appendChild(text);
			imgPar.appendChild(div);
			imgPar.style.height = (rootRect.height | 0) + 'px';
			imgPar.classList.add('chartimg-nodata');
		};
		img.onload = () => {
			img.classList.remove('hide');
			imgPar.appendChild(img);
		};
		const cimg = root.querySelector('.chartimg');
		cimg.style.width = parms.w + 'px';
		if (Tango.isMobile())
			cimg.style.left = (((rect.width - w) / 2) | 0) + 'px';
	}
}

Tango.registerComponent(pricechart);